module.exports = __webpack_public_path__ + "img/pl.8121b6af.png";